import React, { useState } from "react";
import { TicketAttachmentsProps } from "./types";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { getIconBasedOnFileExt } from "../../utils/fetchIconForExtension";
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import { Menu, MenuItem } from "@mui/material";
import FilePreviewModal from "../leads/lead-view/lead-view-details/lead-view-details-view/lead-view-details-view-attachment-info/file-preview-modal";

const TicketAttachments: React.FC<TicketAttachmentsProps> = ({
  attachmentList,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuIndex, setMenuIndex] = useState<number | null>(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [item, setItem] = useState<any>(null);

  const handleMenuOpen = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number,
    item: any
  ) => {
    setAnchorEl(e.currentTarget);
    setMenuIndex(index);
    setItem(item);
  };
  const getFileIcon = (fileName: string) => {
    const ext = fileName?.split(".").pop()?.toLowerCase();
    return getIconBasedOnFileExt(ext || "");
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuIndex(null);
    setItem(null);
  };
  const handleViewFile = () => {
    setPreviewOpen(true);
  };
  const handleDownloadFile = () => {
    const fileUrl = item?.link || item?.file?.url;
    const fileName = item?.file?.original_file_name || "download";
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleMenuClose();
    } else {
      console.warn("No file URL found to download.");
    }
  };

  //to close the view preview for file
  const handleClosePreview = () => {
    setPreviewOpen(false);
    handleMenuClose();
  };

  return (
    <Box className="attachment-list-wrapper">
      {attachmentList?.map((fileItem: any, index: number) => {
        const file = fileItem?.file;
        return (
          <div className="name-icon-wrapper" key={fileItem?.id}>
            <div className="ellipse-icon-wrapper">
              {getFileIcon(file?.original_file_name)}
              {file?.original_file_name}
              <IconButton onClick={(e) => handleMenuOpen(e, index, fileItem)}>
                <MoreHorizIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        );
      })}
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            handleViewFile();
          }}
        >
          View
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleDownloadFile();
          }}
        >
          Download
        </MenuItem>
      </Menu>
      <FilePreviewModal
        open={previewOpen}
        onClose={handleClosePreview}
        fileUrl={item?.link || item?.file?.url}
        fileName={item?.file?.original_file_name}
        id={item?.id}
        previewLink={item?.previewLink}
        size={item?.file?.size}
      />
    </Box>
  );
};

export default TicketAttachments;
